// src/hooks/pricingUnits/useUpdatePricingUnits.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updatePricingUnit } from "../../api/apiPricingUnits";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

const useUpdatePricingUnits = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: updatePricingUnits,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: ({ req, id }) => updatePricingUnit(req, id),
        onSuccess: (response) => {
            toast.success(response.message);
            navigate('/pricing-units');
            queryClient.invalidateQueries({ queryKey: ["pricingUnits"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update pricing unit");
        },
    });

    return {
        updatePricingUnits,
        isPending: isPending || isLoading,
    };
};

export default useUpdatePricingUnits;
